import React from 'react';
import { CommentedDecision } from './CommentedDecision';
import { SearchResultCommentSubtitle } from './SearchResultCommentSubtitle';
import { SearchResultCommentSummary } from './SearchResultCommentSummary';
import { SearchResultCommentTitle } from './SearchResultCommentTitle';
import { SearchComment } from './searchResultComment.types';

type Props = {
  comment: SearchComment;
  originalQueryKey: string;
  index: number;
};

export function SearchResultCommentary({
  comment,
  index,
  originalQueryKey,
}: Props) {
  return (
    <>
      <div className="excerpt_comment__comment">
        <SearchResultCommentTitle
          comment={comment}
          index={index}
          originalQueryKey={originalQueryKey}
        />
        <SearchResultCommentSubtitle comment={comment} />
        <SearchResultCommentSummary
          comment={comment}
          originalQueryKey={originalQueryKey}
        />
      </div>
      <CommentedDecision
        comment={comment}
        originalQueryKey={originalQueryKey}
      />
    </>
  );
}
